import { Inject, Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { TranslatedToastrService } from './translated-toastr.service';
import { MODULE_ENVIRONMENTS } from '..';

export enum MessageStatus {
    Success = 'success',
    Error = 'error',
    Warning = 'warning',
}

@Injectable({ providedIn: 'root' })
export class SignalRService {
    private hubConnection: signalR.HubConnection;

    private baseUrl: string;
    constructor(
        @Inject(MODULE_ENVIRONMENTS) private environment: any,
        private translatedToastrService: TranslatedToastrService
    ) {
        this.baseUrl = environment.apiUrl;
    }

    public startConnection = (channelId: string) => {
        let signalRUrl = this.environment.signalRUrl;
        if (this.baseUrl.indexOf('localhost') == -1) {
            signalRUrl = this.environment.signalRUrl;
        }
        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(signalRUrl + `/messagehub?channelId=${channelId}`)
            .build();

        this.hubConnection
            .start()
            .then(() => console.log('SignalR Connection started'))
            .catch(err => console.log('Error establishing SignalR connection: ' + err));

        this.addMessageListener();
    };

    public addMessageListener = () => {
        this.hubConnection.on('ReceiveMessage', (message: string, messageStatus: MessageStatus) => {
            switch (messageStatus) {
                case MessageStatus.Success:
                    this.translatedToastrService.success(message, 'common.success');
                    break;
                case MessageStatus.Warning:
                    this.translatedToastrService.warning(message, 'common.warning');
                    break;
                case MessageStatus.Error:
                    this.translatedToastrService.error(message, 'common.error');
                    break;
            }
        });
    };
}
